import { useEffect } from 'react';

const STORAGE_KEY = 'planwise:promo-mode';
const PROMO_CLASS = 'promo-mode';

function readParam(): boolean | null {
  const value = new URLSearchParams(window.location.search).get('promo');
  if (value === null) return null;
  return value !== '0' && value.toLowerCase() !== 'false';
}

/**
 * Screenshot/recording mode for marketing captures: `?promo=1` strips the
 * chrome that has no place in a launch video (third-party feedback bubble,
 * toasts, banners, scrollbars) by putting a `promo-mode` class on <html>.
 *
 * The flag is remembered for the tab so it survives client-side navigation —
 * a capture pass moves between /boards, /analytics and the view switcher, and
 * re-appending the query string on every hop would be easy to forget and would
 * show up as one inconsistent frame. `?promo=0` clears it.
 */
export function usePromoMode(): void {
  useEffect(() => {
    const fromUrl = readParam();

    if (fromUrl !== null) {
      try {
        if (fromUrl) sessionStorage.setItem(STORAGE_KEY, '1');
        else sessionStorage.removeItem(STORAGE_KEY);
      } catch {
        // Private mode or blocked storage: fall back to URL-only behaviour.
      }
    }

    let active = fromUrl ?? false;
    if (fromUrl === null) {
      try {
        active = sessionStorage.getItem(STORAGE_KEY) === '1';
      } catch {
        active = false;
      }
    }

    document.documentElement.classList.toggle(PROMO_CLASS, active);
  }, []);
}
